import React from "react";
import { IconProps } from "../icon";

export const SpacingHeight_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 18V6m0 12l-3-2m3 2l3-2M12 6L9 8m3-2l3 2m6-5H3m18 18H3"
    />
  </svg>
);
